import { render, staticRenderFns } from "./StProfileMenu.vue?vue&type=template&id=8694efaa&"
import script from "./StProfileMenu.vue?vue&type=script&lang=js&"
export * from "./StProfileMenu.vue?vue&type=script&lang=js&"
import style0 from "./StProfileMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports